module.exports = __webpack_public_path__ + "media/categories/2015-30072b0f.svg";